export class DashboardRouter {
    
    static getRoute(): string {
        return `/dashboard`
    }

}